import React from 'react';

interface ProfileCircleProps {
  photoURL: string;
  displayName: string;
  className?: string;
  /** When true, shows the SK diamond badge — indicates full ConnectieFlow completed */
  isSuperKonnected?: boolean;
}

/**
 * SK logo badge — het echte SuperKonnected logo in een wit cirkeltje.
 * Verschijnt rechtsboven op de avatar wanneer twee users de volledige
 * ConnectieFlow samen hebben doorlopen.
 */
const SKBadge: React.FC = () => (
  <div
    style={{
      position: 'absolute',
      top: -3,
      right: -3,
      width: 12,
      height: 12,
      borderRadius: '50%',
      background: '#ffffff',
      boxShadow: '0 0 0 1.5px rgba(4,196,222,0.5), 0 1px 3px rgba(0,0,0,0.18)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
      flexShrink: 0,
    }}
    aria-label="SuperKonnected"
  >
    <img
      src="/SuperKonnected_Logo.svg"
      alt=""
      style={{ width: 8, height: 8, objectFit: 'contain', display: 'block' }}
    />
  </div>
);

/**
 * ProfileCircle Component
 * Kleine avatar — visuele representatie van een gebruiker.
 * Toont optioneel een SK diamond badge als deze gebruiker SuperKonnected is.
 */
export const ProfileCircle: React.FC<ProfileCircleProps> = ({ 
  photoURL, 
  displayName,
  className = '',
  isSuperKonnected = false,
}) => {
  const fallbackUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName || 'U')}&background=cccccc&color=fff&size=64`;

  if (!isSuperKonnected) {
    return (
      <img
        src={photoURL || fallbackUrl}
        alt={displayName}
        className={`w-6 h-6 rounded-full object-cover border border-white ${className}`}
        onError={(e) => {
          const target = e.currentTarget as HTMLImageElement;
          target.src = fallbackUrl;
        }}
      />
    );
  }

  // Wrap in relative div to position the badge
  return (
    <div style={{ position: 'relative', display: 'inline-flex', flexShrink: 0 }}>
      <img
        src={photoURL || fallbackUrl}
        alt={displayName}
        className={`w-6 h-6 rounded-full object-cover border border-white ${className}`}
        onError={(e) => {
          const target = e.currentTarget as HTMLImageElement;
          target.src = fallbackUrl;
        }}
      />
      <SKBadge />
    </div>
  );
};

export default ProfileCircle;
